module.exports = __webpack_public_path__ + "img/logo-1.08853782.png";